/** @format */
const nextConfig = require("next/config");
const getConfig = nextConfig.default;

// DO NOT IMPORT the API-side config here. These configs are separated for a reason, unless you'd like
// to explain to IT security why you revealed our secret keys to the entire world.
const getQAConfig = require("./qa");
const getProdConfig = require("./production");

const envs = {
  qa: getQAConfig,
  prod: getProdConfig,
  production: getProdConfig,
};

// [psears 3/28/18]: @lukasz this is an example of the new Next config util. Look how pretty.
// in qa, this call returns undefined (next.config.js is not read under test)
const { publicRuntimeConfig = {} } = getConfig() || {};

const isServer = typeof window === "undefined";
const awsAccount = publicRuntimeConfig.awsAccount || "qa";
const isQa = awsAccount === "qa";
const isProduction = awsAccount === "prod" || isQa;

const getGatewayUrl = () => {
  return isServer ? "http://localhost:8000" : "";
};

let config = {
  isServer,
  isProduction,
  isQa,
  // There is currently no code that uses this value, and there SHOULD NOT BE.
  // It is here for reference (e.g. logging), and to import the correct URL set.
  applicationEnv: awsAccount,

  // This url points API requests to the localhost on serverside, and to the window.location.host
  // on client side.
  GATEWAY_URL: getGatewayUrl(),

  CDN_PREFIX: isServer ? process.env.CDN_PREFIX || "" : window.FARCDN || "",
};

// Allow for aws-account specific overrides
const getEnvConfig = envs[awsAccount] || envs.production;
config = {
  ...config,
  ...getEnvConfig,
  DYNAMIC_URL_PATH: "realtors",
};

module.exports = {
  ...config,
};
